export enum ActionButtonType {
    VIEW = 'view',
    EDIT = 'edit',
    REMOVE = 'remove',
    TEST_RUN = 'test-run',
    RUNS = 'runs',
}
